<template>
    <div>
        <footer class="primary">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 offset-md-1">
                        <div class="row">
                            <div class="col-7 col-md-3">
                                <div class="row">
                                    <div class="col-md-12">
                                        <img src="/static/images/logos/alphabet-branca.svg" alt="" class="img-fluid">
                                    </div>
                                    
                                </div>
                            </div>
                            <div class="col-5 col-md-7 offset-md-1">
                                <div class="row">
                                    <div class="col-md-12">
                                        <nav-links :items="items" :ulClass="'nav'"></nav-links>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row complementary-info">
                    <div class="col-md-4 offset-md-5">
                        <p>Address</p>
                        <p>{{ info.address.street }} <br class="hide">
                            <!-- {{ info.address.complement }} <br> -->
                            {{ info.address.city }}
                        </p>
                    </div>
                    <div class="col-md-3">
                        <p>Phone</p>
                        <p>{{ info.phone }}</p>
                    </div>
                </div>			
            </div>
        </footer>

        <footer class="secondary">
            <div class="container">
                <div class="row">
                    <div class="col-md-10 offset-md-1">
                        <div class="row">
                            <div class="col-md-9">
                                &copy; All rights reserved.
                            </div>
                            <div class="col-md-3">
                                Powered by Viitra
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
    export default {
        props: ['info', 'items'],
    }
</script>


// WEBPACK FOOTER //
// src/components/Footer.vue